import { WORKING_ORDER } from "constants/action-types";
import { IWorkingDraftsState } from "reducers/working-order/working";

export const validateDraft = (body) => ({
    type: WORKING_ORDER.DRAFTS.VALIDATE,
    payload: { url: "/draft/validate", body },
});

export const update = (payload: Partial<IWorkingDraftsState>) => ({
    type: WORKING_ORDER.DRAFTS.UPDATE,
    payload,
});

export const fetchCart = () => ({
    type: WORKING_ORDER.FETCH_CART,
});
